function Activity() {


    return (
        <svg
    version="1.1"
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    style={{ enableBackground: "new 0 0 24 24" }}
    xmlSpace="preserve"
  >
    <style
      type="text/css"
      dangerouslySetInnerHTML={{
        __html:
          "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:#E5E5E5;}\n\t.st3{fill:#E5E5E5;}\n\t.st4{display:inline;fill:#FFFFFF;}\n"
      }}
    />
    <g id="Layer_3" className="st0">
      <rect className="st1" width={24} height={24} />
    </g>
    <g id="_x23_262626ff" className="st0"></g>
    <g id="_x23_ffffffff" className="st0">
      <path
        className="st2"
        d="M0.7,3.2C1.1,3,1.6,3,2.1,3c6.7,0,13.4,0,20.1,0C23.1,2.9,24,3.6,24,4.5c0,0.9-0.9,1.6-1.8,1.5
		C15.5,6,8.8,6,2.1,6C1.5,6,0.7,6,0.3,5.4C-0.3,4.7,0,3.6,0.7,3.2z"
      />
      <path
        className="st2"
        d="M0.8,10.7c0.4-0.2,0.9-0.2,1.3-0.2c6.7,0,13.4,0,20.1,0c0.9-0.1,1.8,0.6,1.8,1.5c0,0.9-0.9,1.6-1.8,1.5
		c-6.7,0-13.4,0-20.1,0c-0.6,0-1.4,0-1.8-0.6C-0.3,12.2,0,11.1,0.8,10.7z"
      />
      <path
        className="st2"
        d="M0.8,18.2C1.2,18,1.6,18,2.1,18c6.7,0,13.4,0,20.1,0c0.7-0.1,1.4,0.3,1.7,0.9c0.5,0.9-0.3,2.1-1.3,2.1
		c-6.8,0-13.6,0-20.4,0c-0.6,0-1.4,0-1.8-0.6C-0.3,19.7,0,18.6,0.8,18.2z"
      />
    </g>
    <g id="_x23_e5e5e5ff" className="st0">
      <path
        className="st2"
        d="M10.3,0.2c1.6-0.4,3.4-0.2,4.8,0.5c2.2,1.1,3.8,3.4,3.9,5.9c0.2,2.4-1,4.7-2.9,6.1c4.4,1.5,7.6,5.8,7.9,10.4
		c0,0.7-0.9,1.3-1.5,0.9c-0.5-0.3-0.5-0.9-0.6-1.4c-0.4-2.7-1.9-5.1-4.1-6.6c-2.4-1.8-5.6-2.2-8.4-1.5c-3.3,0.8-6,3.5-7,6.7
		c-0.3,0.8-0.2,1.8-0.6,2.5C1.3,24.4-0.1,23.9,0,23c0.3-4.6,3.6-8.8,7.9-10.3c-1.3-0.9-2.2-2.3-2.6-3.8C4.8,7,5,4.9,6.1,3.3
		C7,1.8,8.5,0.6,10.3,0.2 M10.9,2.1C9.3,2.4,8,3.6,7.4,5C6.8,6.5,6.9,8.2,7.7,9.5c0.8,1.3,2.1,2.3,3.7,2.4c1.6,0.2,3.2-0.4,4.3-1.5
		c1.2-1.2,1.6-3.2,1.2-4.8C16.1,3.1,13.4,1.5,10.9,2.1z"
      />
    </g>
    <g id="_x23_e5e5e5ff_00000059309478266267941320000001716134725718594979_">
      <path
        className="st3"
        d="M9.9,0.2c2.9-0.5,5.9,0,8.4,1.6c2.5,1.6,4.5,4,5.3,6.8c0.8,3.1,0.6,6.5-1,9.3c-1.4,2.4-3.6,4.4-6.3,5.4
		c-2.7,1-5.8,1-8.5,0c-2.6-1-4.8-3-6.3-5.4c-1.4-2.5-1.8-5.5-1.3-8.3C1.1,4.9,5.2,1,9.9,0.2 M8.7,6.9C9.4,7,10.2,7,11,7
		c0-1.5,0-3.1,0-4.6C9.9,3.6,9.1,5.2,8.7,6.9 M13,2.4c0,1.5,0,3.1,0,4.6c0.8,0,1.6,0,2.4-0.1C14.9,5.3,14.2,3.6,13,2.4 M3.9,6.2
		c0.9,0.2,1.8,0.4,2.8,0.5C7,5.3,7.5,4,8.3,2.7C6.5,3.4,5,4.7,3.9,6.2 M15.8,2.7c0.7,1.2,1.2,2.6,1.6,4c0.9-0.1,1.9-0.3,2.8-0.5
		C19,4.7,17.5,3.4,15.8,2.7 M2.8,8c-0.4,1-0.6,2-0.8,3c1.3,0,2.7,0,4,0c0-0.8,0.1-1.6,0.2-2.3C5.1,8.5,4,8.3,2.8,8 M17.8,8.7
		C17.9,9.4,18,10.2,18,11c1.3,0,2.7,0,4,0c-0.1-1-0.4-2.1-0.8-3C20.1,8.3,18.9,8.5,17.8,8.7 M8.2,8.9C8.2,9.6,8.1,10.3,8,11
		c1,0,2,0,3,0c0-0.7,0-1.4,0-2.1C10.1,9,9.2,9,8.2,8.9 M13,9c0,0.7,0,1.4,0,2.1c1,0,2,0,3,0c0-0.7-0.1-1.4-0.2-2.1
		C14.9,9,13.9,9,13,9 M2.1,13c0.1,1,0.4,2.1,0.8,3c1.1-0.3,2.3-0.5,3.4-0.7C6.2,14.6,6.1,13.8,6,13C4.7,13,3.4,13,2.1,13 M8,13
		c0,0.7,0.1,1.4,0.2,2.1c0.9-0.1,1.8-0.1,2.8-0.1c0-0.7,0-1.4,0-2C10,13,9,13,8,13 M13,13c0,0.7,0,1.4,0,2c0.9,0,1.9,0,2.8,0.1
		c0.1-0.7,0.2-1.4,0.2-2.1C15,13,14,13,13,13 M18,13c0,0.8-0.1,1.6-0.2,2.3c1.2,0.2,2.3,0.4,3.4,0.7c0.4-1,0.7-2,0.8-3
		C20.7,13,19.3,13,18,13 M8.7,17.1c0.5,1.7,1.1,3.3,2.3,4.6c0-1.5,0-3.1,0-4.6C10.2,17.1,9.5,17.1,8.7,17.1 M13,17
		c0,1.5,0,3.1,0,4.6c1.2-1.3,1.9-2.9,2.3-4.6C14.6,17.1,13.8,17.1,13,17 M3.9,17.8c1.1,1.5,2.6,2.7,4.4,3.5c-0.8-1.2-1.2-2.6-1.6-4
		C5.7,17.4,4.8,17.6,3.9,17.8 M15.8,21.3c1.7-0.7,3.2-2,4.4-3.5c-0.9-0.2-1.8-0.4-2.8-0.5C17,18.7,16.5,20.1,15.8,21.3z"
      />
    </g>
    <g
      id="_x23_e5e5e5ff_00000183250023799203021590000013081205298951287726_"
      className="st0"
    >
      <path
        className="st2"
        d="M11.7,0.6c0.3-0.2,0.7-0.1,1,0c3.5,1.3,7,2.5,10.5,3.8c0.3,0.1,0.8,0.3,0.9,0.7c0.2,0.5-0.1,1.2-0.7,1.4
		c-0.4,0.1-0.8,0-1.2,0c0,0.8,0.1,1.6-0.1,2.4c-0.3,0.8-1.2,0.6-1.9,0.6c0,2.3,0,4.6,0,7c0.7,0,1.6-0.1,1.9,0.6
		c0.2,0.8,0,1.6,0.1,2.4c0.7,0,1.6-0.1,1.9,0.6c0.2,0.8,0,1.7,0.1,2.6c0,0.5,0.1,1.1-0.3,1.5c-0.2,0.3-0.6,0.3-0.9,0.3
		c-7.2,0-14.4,0-21.5,0c-0.5,0.1-1.1-0.3-1.2-0.8c-0.1-0.9,0-1.7,0-2.6c0-0.4-0.1-1,0.3-1.3c0.4-0.4,1.1-0.3,1.7-0.3
		c0-0.8-0.1-1.6,0.1-2.4c0.3-0.8,1.2-0.6,1.9-0.6c0-2.3,0-4.6,0-7c-0.7,0-1.6,0.1-1.9-0.6c-0.2-0.8,0-1.6-0.1-2.4
		c-0.4,0-0.8,0-1.2,0C0.4,6.4,0,5.6,0.3,5c0.1-0.3,0.5-0.5,0.8-0.6C4.7,3.2,8.2,1.9,11.7,0.6 M6.9,4.5c3.5,0.1,7,0,10.5,0
		c-1.8-0.6-3.5-1.3-5.3-1.9C10.4,3.2,8.7,3.9,6.9,4.5 M4.2,6.5c0,0.3,0,0.7,0,1c5.3,0,10.6,0,15.9,0c0-0.3,0-0.7,0-1
		C14.8,6.5,9.5,6.5,4.2,6.5 M6.2,9.5c0,2.3,0,4.7,0,7c0.3,0,0.7,0,1,0c0-2.3,0-4.7,0-7C6.9,9.5,6.5,9.5,6.2,9.5 M9.2,9.5
		c0,2.3,0,4.7,0,7c0.7,0,1.3,0,2,0c0-2.3,0-4.7,0-7C10.5,9.5,9.8,9.5,9.2,9.5 M13.2,9.5c0,2.3,0,4.7,0,7c0.7,0,1.3,0,2,0
		c0-2.3,0-4.7,0-7C14.5,9.5,13.8,9.5,13.2,9.5 M17.2,9.5c0,2.3,0,4.7,0,7c0.3,0,0.7,0,1,0c0-2.3,0-4.7,0-7
		C17.8,9.5,17.5,9.5,17.2,9.5 M4.2,18.4c0,0.3,0,0.7,0,1c5.3,0,10.6,0,15.9,0c0-0.3,0-0.7,0-1C14.8,18.4,9.5,18.4,4.2,18.4
		 M2.2,21.4c0,0.3,0,0.7,0,1c6.6,0,13.3,0,19.9,0c0-0.3,0-0.7,0-1C15.5,21.4,8.8,21.4,2.2,21.4z"
      />
    </g>
    <g
      id="_x23_ffffffff_00000103987296018067770790000004652659034538069156_"
      className="st0"
    >
      <path
        className="st4"
        d="M2.1,1.7C2,1.1,2.6,0.4,3.3,0.5c5.9,0,11.9,0,17.8,0c0.7,0,1.2,1,0.8,1.5c-0.4,0.6-1.2,0.4-1.8,0.4
		c0,0.7,0,1.3,0,2c0.6,0.1,1.3-0.2,1.7,0.3C22,5.1,22,5.5,22,5.9c0,5.8,0,11.6,0,17.4c0.1,0.7-0.5,1.2-1.2,1.2c-5.9,0-11.7,0-17.6,0
		c-0.6,0-1.2-0.4-1.2-1C2.1,16.2,2.1,9,2.1,1.7 M4.1,2.5c0,0.7,0,1.3,0,2c4.7,0,9.3,0,14,0c0-0.7,0-1.3,0-2
		C13.4,2.5,8.7,2.5,4.1,2.5 M4.1,6.5c0,5.3,0,10.6,0,15.9c1,0,2,0,3,0c0-5.3,0-10.6,0-15.9C6.1,6.5,5.1,6.5,4.1,6.5 M9.1,6.5
		c0,5.3,0,10.6,0,15.9c3.7,0,7.3,0,11,0c0-5.3,0-10.6,0-15.9C16.4,6.5,12.7,6.5,9.1,6.5z"
      />
      <path
        className="st4"
        d="M11.6,10.7c0.3-0.2,0.7-0.1,1.1-0.2c1.5,0,3,0,4.4,0c0.5,0,1,0.5,1,1c0,1,0,2,0,3c0,0.5-0.4,1-1,1
		c-1.6,0-3.2,0-4.8,0c-0.6,0.1-1.2-0.4-1.2-1c0-0.9,0-1.9,0-2.8C11,11.3,11.2,10.9,11.6,10.7 M13.1,12.5c0,0.3,0,0.7,0,1
		c1,0,2,0,3,0c0-0.3,0-0.7,0-1C15.1,12.5,14.1,12.5,13.1,12.5z"
      />
    </g>
    <g
      id="_x23_e5e5e5ff_00000143618635339139717610000009705044459080775303_"
      className="st0"
    >
      <path
        className="st2"
        d="M3.5,0.8c0.4-0.4,1-0.3,1.5-0.3c1.5,0,3-0.1,4.5,0.1c0.8,0.3,0.7,1.3,0.7,1.9c1.3,0,2.6,0,4,0
		c0-0.6-0.1-1.3,0.3-1.7c0.4-0.4,1-0.3,1.5-0.3c1.5,0,3-0.1,4.5,0.1c0.8,0.3,0.7,1.3,0.7,1.9c0.8,0,1.6-0.1,2.3,0.1
		c0.4,0.2,0.7,0.7,0.6,1.1c0,6.5,0,13,0,19.6c0.1,0.7-0.5,1.2-1.2,1.2c-7.1,0-14.2,0-21.4,0c-0.5,0-1.2-0.1-1.3-0.7
		c-0.1-0.5-0.1-1-0.1-1.5c0-6.2,0-12.4,0-18.6c0-0.5,0.2-0.9,0.6-1.1c0.8-0.1,1.6,0,2.3-0.1C3.2,2,3,1.3,3.5,0.8 M5.2,2.5
		c0,0.7,0,1.3,0,2c1,0,2,0,3,0c0-0.7,0-1.3,0-2C7.1,2.5,6.2,2.5,5.2,2.5 M16.1,2.5c0,0.7,0,1.3,0,2c1,0,2,0,3,0c0-0.7,0-1.3,0-2
		C18.1,2.5,17.1,2.5,16.1,2.5 M2.2,4.5c0,1.3,0,2.7,0,4c6.6,0,13.3,0,19.9,0c0-1.3,0-2.7,0-4c-0.3,0-0.7,0-1,0c0,0.7,0.1,1.8-0.8,2
		c-1.5,0.1-2.9,0-4.4,0c-0.5,0-1.1,0.1-1.5-0.3c-0.4-0.4-0.3-1.1-0.3-1.7c-1.3,0-2.6,0-4,0c0,0.7,0.1,1.8-0.8,2
		c-1.5,0.1-2.9,0-4.4,0c-0.5,0-1.1,0.1-1.5-0.3C3,5.8,3.2,5.1,3.2,4.5C2.8,4.5,2.5,4.5,2.2,4.5 M2.2,10.5c0,4,0,8,0,12
		c6.6,0,13.3,0,19.9,0c0-4,0-8,0-12C15.5,10.5,8.8,10.5,2.2,10.5z"
      />
      <path
        className="st2"
        d="M5,12.5c0.7-0.1,1.4,0,2.2,0c0.5,0,1,0.4,1,0.9c0,0.6,0.2,1.3-0.3,1.7c-0.4,0.4-1.1,0.3-1.7,0.3
		c-0.6,0-1.3,0.1-1.7-0.3C4,14.7,4.2,14,4.2,13.5C4.2,13,4.5,12.6,5,12.5z"
      />
      <path
        className="st2"
        d="M11,12.5c0.7-0.1,1.4,0,2.2,0c0.5,0,1,0.4,1,1c0,0.6,0.2,1.3-0.3,1.7c-0.4,0.4-1.1,0.3-1.7,0.3
		c-0.6,0-1.3,0.1-1.7-0.3c-0.4-0.4-0.3-1-0.3-1.5C10.1,13.2,10.4,12.6,11,12.5z"
      />
      <path
        className="st2"
        d="M16.9,12.5c0.7-0.1,1.5,0,2.2,0c0.5,0,1,0.4,1,1c0,0.6,0.2,1.3-0.3,1.7c-0.4,0.4-1.1,0.3-1.7,0.3
		c-0.7,0-1.6,0.1-1.9-0.6C16.1,14.1,15.9,12.7,16.9,12.5z"
      />
      <path
        className="st2"
        d="M5,17.5c0.7-0.1,1.4,0,2.2,0c0.5,0,1,0.4,1,0.9c0,0.7,0.2,1.7-0.6,2c-0.8,0.1-1.6,0.1-2.4,0.1
		c-0.6,0-1-0.6-1-1.2C4.1,18.6,4.1,17.6,5,17.5z"
      />
      <path
        className="st2"
        d="M11,17.5c0.8,0,1.7-0.1,2.5,0c0.8,0.3,0.7,1.3,0.7,2c0,0.5-0.5,1-1,0.9c-0.8,0-1.6,0.1-2.4-0.1
		c-0.7-0.3-0.7-1.1-0.6-1.8C10.1,18.1,10.4,17.6,11,17.5z"
      />
      <path
        className="st2"
        d="M17,17.5c0.7-0.1,1.5,0,2.2,0c0.5,0,1,0.4,1,1c0,0.7,0.2,1.6-0.6,1.9c-0.8,0.2-1.6,0.1-2.4,0.1
		c-0.6,0-1-0.6-1-1.2C16,18.6,16.1,17.6,17,17.5z"
      />
    </g>
    <g
      id="_x23_e5e5e5ff_00000178916699622732163050000013266214814915520423_"
      className="st0"
    >
      <path
        className="st2"
        d="M0.8,3.5c7.4-0.1,14.9,0,22.3,0c0.5-0.1,1,0.5,1,1c0,5.3,0,10.7,0,16c0.1,0.6-0.6,1.1-1.2,1
		c-7.3,0-14.5,0-21.8,0c-0.5,0-1.1-0.4-1-1c0-5.3,0-10.6,0-16C0.2,4.1,0.5,3.7,0.8,3.5 M3.8,5.5c2.8,2.5,5.6,5.1,8.4,7.6
		c2.8-2.5,5.6-5.1,8.4-7.6C15,5.5,9.4,5.5,3.8,5.5 M2.2,6.8c0,3.8,0,7.5,0,11.3c2-2,4-3.9,6-5.9C6.2,10.4,4.2,8.6,2.2,6.8
		 M16.1,12.2c1.9,2,4,3.8,6,5.8c0-3.7,0-7.5,0-11.2C20.1,8.6,18.1,10.4,16.1,12.2 M3.6,19.4c5.7,0,11.4,0,17.1,0
		c-2-2-4.1-3.9-6.1-5.9c-0.7,0.6-1.3,1.2-1.9,1.7c-0.3,0.3-0.9,0.3-1.2,0c-0.7-0.6-1.3-1.2-1.9-1.7C7.6,15.5,5.6,17.5,3.6,19.4z"
      />
    </g>
    <g
      id="_x23_e5e5e5ff_00000106855317993874251070000007426748790159453357_"
      className="st0"
    >
      <path
        className="st2"
        d="M1.1,1.6C1,1,1.5,0.4,2.1,0.4c5.9,0,11.7,0,17.6,0c0.4,0,0.8,0,1.1,0.3C21.1,1,21,1.6,21.1,2
		c0,3.1,0,6.3,0,9.4c0,0.7-0.8,1.2-1.4,0.9c-0.4-0.2-0.7-0.7-0.6-1.1c0-2.9,0-5.9,0-8.8c-5.3,0-10.6,0-15.9,0c0,6.6,0,13.3,0,19.9
		c3.3,0,6.7,0,10,0c0.7,0,1.2,0.8,0.9,1.4c-0.2,0.4-0.7,0.7-1.1,0.6c-3.6,0-7.2,0-10.8,0c-0.6,0-1-0.6-1-1.2C1.1,16,1.1,8.8,1.1,1.6
		z"
      />
      <path
        className="st2"
        d="M5.9,4.4c2.7-0.1,5.3,0,8,0c0.4,0,0.9,0.2,1.1,0.6c0.3,0.6-0.2,1.4-0.9,1.4c-2.6,0-5.2,0-7.8,0
		c-0.4,0-0.8-0.1-1-0.5C4.9,5.3,5.3,4.5,5.9,4.4z"
      />
      <path
        className="st2"
        d="M5.9,8.4c3.4,0,6.8,0,10.1,0c0.7,0,1.2,0.7,0.9,1.4c-0.2,0.4-0.7,0.7-1.1,0.6c-3.2,0-6.4,0-9.6,0
		c-0.4,0-0.9-0.2-1.1-0.6C4.9,9.2,5.3,8.5,5.9,8.4z"
      />
      <path
        className="st2"
        d="M5.9,12.4c2.8-0.1,5.7,0,8.5,0c0.4,0,1-0.1,1.3,0.3c0.4,0.4,0.4,1,0,1.4c-0.3,0.3-0.7,0.3-1.1,0.3
		c-2.8,0-5.6,0-8.4,0c-0.5,0-0.9-0.2-1.1-0.6C4.9,13.2,5.3,12.5,5.9,12.4z"
      />
      <path
        className="st2"
        d="M19.9,14.4c0.9,0,1.6,0.7,2.4,1c0.6,0.2,1,0.9,0.6,1.5c-0.9,1.8-1.8,3.5-2.6,5.3c-0.2,0.4-0.4,0.9-0.9,1.1
		c-0.6,0.3-1.3,0.7-1.9,1c-0.6,0.3-1.4-0.2-1.4-0.9c0-1-0.2-2,0.3-2.9c0.9-1.8,1.8-3.5,2.7-5.3C19.2,14.8,19.5,14.4,19.9,14.4z"
      />
      <path
        className="st2"
        d="M5.9,16.4c1-0.1,2,0,3,0c0.5,0,0.9,0.2,1.1,0.6c0.3,0.6-0.2,1.4-0.9,1.4c-1.1,0-2.2,0-3.3,0
		C4.9,18.1,4.9,16.5,5.9,16.4z"
      />
    </g>
    <g
      id="_x23_e5e5e5ff_00000121270353157492855610000005839018797187808946_"
      className="st0"
    >
      <path
        className="st2"
        d="M19.6,1.7c0.4-0.3,1-0.1,1.3,0.2c0.9,0.9,1.7,1.7,2.6,2.6c0.3,0.3,0.6,0.6,0.6,1c0,0.4-0.3,0.7-0.6,1
		c-2.2,2.2-4.3,4.3-6.5,6.5c-0.4,0.5-1.1,0.6-1.6,0.8c-1.2,0.4-2.3,0.8-3.5,1.1c-0.7,0.3-1.5-0.5-1.2-1.2c0.4-1.4,0.9-2.8,1.4-4.2
		c0.2-0.6,0.7-1,1.1-1.5c1.8-1.8,3.6-3.6,5.4-5.4C19,2.3,19.3,2,19.6,1.7 M14.2,10c-0.5,0.8-0.6,1.7-0.9,2.5c1-0.4,2.2-0.4,2.9-1.3
		c1.8-1.9,3.7-3.7,5.6-5.6c-0.5-0.5-1-1-1.6-1.6C18.2,6,16.2,8,14.2,10z"
      />
      <path
        className="st2"
        d="M0.2,4.7c-0.1-0.6,0.4-1.2,1-1.2c4.1,0,8.3,0,12.4,0c0.7-0.1,1.3,0.7,1,1.4c-0.2,0.5-0.7,0.6-1.2,0.6
		c-3.7,0-7.5,0-11.2,0c0,5.3,0,10.6,0,15.9c5.3,0,10.6,0,15.9,0c0-2.5,0-4.9,0-7.4c0-0.5,0.4-1.1,1-1.1c0.6,0,1,0.5,1,1.1
		c0,2.6,0,5.2,0,7.8c0,0.4,0.1,1-0.3,1.3c-0.3,0.3-0.9,0.3-1.3,0.3c-5.7,0-11.4,0-17.2,0c-0.6,0-1.2-0.4-1.2-1
		C0.2,16.6,0.2,10.7,0.2,4.7z"
      />
    </g>
    <g
      id="_x23_e5e5e5ff_00000012449601343193455620000003598362685826638725_"
      className="st0"
    >
      <path
        className="st2"
        d="M10.2,0.6c2.7-0.4,5.5,0,7.9,1.4c2.8,1.7,5,4.5,5.7,7.8c0.6,3,0.2,6.4-1.6,9c-1.5,2.4-3.9,4.3-6.6,5.1
		c-3.1,0.9-6.7,0.6-9.5-1.1c-0.4-0.2-0.9-0.5-1-1c-0.2-0.7,0.6-1.4,1.3-1.1c0.5,0.2,1,0.6,1.6,0.8c2.8,1.3,6.3,1.2,9-0.4
		c1.9-1.1,3.4-2.7,4.3-4.7c1-2.4,1.1-5.1,0.2-7.5c-1-2.5-3-4.6-5.5-5.7c-2.7-1.1-5.8-1-8.4,0.3C7,3.8,6.4,4.4,5.7,4.1
		C5.1,3.9,4.8,3,5.4,2.5C6.8,1.5,8.5,0.9,10.2,0.6z"
      />
      <path
        className="st2"
        d="M4.2,7.9C4.5,7.5,5,7.2,5.5,7.5c0.6,0.3,0.7,1.1,0.3,1.6c-0.7,0.8-1.5,1.5-2.3,2.3c3.8,0,7.7,0,11.5,0
		c0.7,0,1.2,0.8,0.9,1.4c-0.2,0.4-0.6,0.7-1.1,0.6c-3.8,0-7.6,0-11.3,0c0.8,0.8,1.5,1.5,2.3,2.3C6.1,16,6.2,16.6,5.9,17
		c-0.3,0.5-1.1,0.5-1.5,0.1c-1.3-1.3-2.6-2.6-3.9-3.9C0,12.8,0,12.1,0.4,11.7C1.6,10.4,2.9,9.2,4.2,7.9z"
      />
    </g>
  </svg>
    )
}


export default Activity;